var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongShuomingMian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 7,
    transform: "matrix(1 0 0 -1 8 8)",
    fill: "#3F465C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3V7",
    stroke: "#fff",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 4.9a.6.6 0 10-1.2 0 .6.6 0 001.2 0z",
    fill: "#fff"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSByPSI3IiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSA4IDgpIiBmaWxsPSIjM0Y0NjVDIi8+CjxwYXRoIGQ9Ik04IDExLjNWNy4wMDAwNiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik04LjYwMDAyIDQuOUM4LjYwMDAyIDQuNTY4NjMgOC4zMzE0IDQuMyA4LjAwMDAyIDQuM0M3LjY2ODY1IDQuMyA3LjQwMDAyIDQuNTY4NjMgNy40MDAwMiA0LjlDNy40MDAwMiA1LjIzMTM3IDcuNjY4NjUgNS41IDguMDAwMDIgNS41QzguMzMxNCA1LjUgOC42MDAwMiA1LjIzMTM3IDguNjAwMDIgNC45WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";
export { SvgTongyongShuomingMian as ReactComponent };